import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';


export default function buscarUltimosHistoricosPassageiro (idPedido, idEmpresa) {
  let url = `${URL}/passageiro/${idPedido}/empresa/${idEmpresa}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO,
        payload: response

      })
  );
}